import React from 'react';

import { FiExternalLink } from '@fmbt/ui/icons';
import TypographyLink from '@fmbt/ui/TypographyLink';

interface NewTabLinkProps {
  disabled?: boolean;
  href: string;
  iconSize?: number;
  internalAdmin?: boolean;
  text?: React.ReactNode;
}

/**
 * A wrapper of TypographyLink that ensures we do not forget the FiExternalLink icon.
 *
 * Note: Unlike IconLabel that puts icon in front of (or beneath) the label, this component puts the icon after the text.
 * */
function NewTabLink({ disabled, href, iconSize, internalAdmin, text }: NewTabLinkProps) {
  const iconStyle = text
    ? { verticalAlign: 'text-bottom', marginLeft: 4 }
    : { verticalAlign: 'middle' };

  return (
    <TypographyLink disabled={disabled} href={href} internalAdmin={internalAdmin} target="_blank">
      {text}
      <FiExternalLink size={iconSize || 18} style={iconStyle} />
    </TypographyLink>
  );
}

export default NewTabLink;